import React, { useState, useEffect } from 'react';
import Cell from './Cell';
// import './CrosswordGrid.css';  // Optional for additional styling

const crosswordData = [
  { word: "APPLE", row: 0, col: 0, direction: "across" },
  { word: "BIRD", row: 0, col: 2, direction: "down" },
];

const gridSize = 10; // Adjust the grid size as needed

const CrosswordGrid = () => {
  const [grid, setGrid] = useState(Array(gridSize).fill(null).map(() => Array(gridSize).fill('')));

  const initializeGrid = () => {
    let newGrid = Array(gridSize).fill(null).map(() => Array(gridSize).fill(''));

    crosswordData.forEach(({ word, row, col, direction }) => {
      for (let i = 0; i < word.length; i++) {
        if (direction === "across") {
          newGrid[row][col + i] = word[i];
        } else if (direction === "down") {
          newGrid[row + i][col] = word[i];
        }
      }
    });

    setGrid(newGrid);
  };

  useEffect(() => {
    initializeGrid();
  }, []);

  return (
    <div className="grid">
      {grid.map((row, rowIndex) => (
        <div key={rowIndex} className="row">
          {row.map((letter, colIndex) => (
            <Cell key={colIndex} letter={letter} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default CrosswordGrid;
